/// <amd-module name="Artifacts/Pypi/redux/Module" />
import { PackageModule } from "Artifacts/Package/redux";
import { rootSaga } from "Artifacts/Pypi/redux/Sagas";
import { ISagaModule } from "redux-dynamic-modules-saga";

const _PypiModule: ISagaModule<Record<string, never>> = {
  id: "pypi-protocol-module",
  reducerMap: {},
  sagas: [rootSaga],
};

export const PypiModule = [PackageModule, _PypiModule];
